module.exports = __webpack_public_path__ + "static/media/allstar_ambassador.01a3dc55.png";